import React from "react";

export default function Error() {
  return (
    <div className="orenda-frontend">
      <div className="loader message">
        <p>Unfortunately an error occured.</p>
      </div>
    </div>
  );
}
